import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Clock } from 'lucide-react';

function Events() {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Events',
        page_path: window.location.pathname,
      });
    }
  }, []);

  const isFR = i18n.language === 'fr';

  return (
    <div className="events-page" data-testid="events-page">
      <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-warm-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <div className="overline mb-4">{isFR ? 'Nos Événements' : 'Our Events'}</div>
          <h1 className="font-playfair text-5xl md:text-7xl tracking-tighter leading-[1.1] font-medium text-charcoal mb-6">
            {isFR ? 'Événements CasaPooch' : 'CasaPooch Events'}
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-charcoal/80">
            {isFR
              ? 'Rejoignez-nous pour des événements spéciaux, des ateliers et des rencontres communautaires pour les amoureux des chiens.'
              : 'Join us for special events, workshops, and community meetups for dog lovers.'}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-warm-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          {/* Upcoming Events Placeholder */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-accent/10 rounded-3xl p-12 md:p-16 text-center"
            data-testid="events-coming-soon"
          >
            <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-primary/10 flex items-center justify-center">
              <Calendar className="w-10 h-10 text-primary" />
            </div>
            <h2 className="font-playfair text-3xl md:text-4xl font-medium text-charcoal mb-4">
              {isFR ? 'Événements à venir' : 'Coming Soon'}
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-charcoal/80 mb-8 max-w-xl mx-auto">
              {isFR
                ? 'Nous planifions des événements passionnants pour la communauté CasaPooch. Restez à l\'écoute pour les ateliers de toilettage, les rencontres canines et plus encore!'
                : 'We are planning exciting events for the CasaPooch community. Stay tuned for grooming workshops, puppy meetups, seasonal celebrations, and more!'}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                className="px-8 py-3 rounded-full bg-primary hover:bg-charcoal text-white transition-colors duration-300 font-medium"
                data-testid="events-contact-btn"
              >
                {isFR ? 'Restez informé' : 'Stay Updated'}
              </Link>
              <a
                href="https://www.instagram.com/lecasapooch/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 rounded-full border border-primary text-primary hover:bg-accent/20 transition-colors duration-300 font-medium"
                data-testid="events-follow-btn"
              >
                {isFR ? 'Suivez-nous' : 'Follow @lecasapooch'}
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Events;
